import AddIcon from '@mui/icons-material/Add';
import { Box, Fab } from '@mui/material';
import React from 'react';
import { useRedirect } from 'react-admin';

const CreateSectionButton = () => {
  const redirect = useRedirect();
  const handleCreate = () => {
    redirect('#/section_informations/create');
  };

  return (
    <Box 
      position="fixed" 
      bottom={16} 
      right={16} 
      zIndex={1000}
    >
      <Fab 
        color="primary" 
        aria-label="Criar nova seção"
        onClick={handleCreate}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default CreateSectionButton;
